import { IAffairPutApi } from "@api/affair.int";
import { Box, FormControl, FormErrorMessage, FormLabel, Input, Textarea, useBoolean, useToast } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { DeepErrorBox, DeepErrorContainer } from "components/misc";
import { useVVStore } from "components/store";
import { VizvButtonCancel, VizvButtonPrimary, VizvCardActionStrip } from "components/vizvComponents";
import { useContext, useState } from "react";
import { MdSave } from "react-icons/md";
import { useNavigate } from "react-router";
import { AffairContext } from "./Affair";
import { AFFAIR_DESCRIPTION_MAX, AFFAIR_DESCRIPTION_MIN, AFFAIR_TITLE_MAX, AFFAIR_TITLE_MIN } from "components/utils";
import { useVVNav } from "components/vvNav";



export function AffairEdit() {
	const ctx = useContext(AffairContext);
	const vvNav = useVVNav();
	const store = useVVStore();

	const api = useVVApi();
	const [title, setTitle] = useState(ctx.affair.title);
	const [description, setDescription] = useState(ctx.affair.description);

	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');
	const toast = useToast();


	const saveClick = async () => {
		setIsLoading.on();
		setError('');
		try {
			///debugger;
			const resp = await api.fetch<IAffairPutApi>({
				url: '/affair/:affairKey',
				method: 'PUT',
				payload: {
					affair: {
						title,
						longLat: ctx.affair.longLat,
						affairKind: ctx.affair.affairKind,
						description
					}
				},
				params: {
					affairKey: ctx.affair.affairKey
				}
			});

			store.addAffairItems([resp.affair]);
			//store.addGroupItems(resp.groups);
			store.resetAfterAction();
			vvNav.toDetail('/affair/' + resp.affair.affairKey);
			toast({ title: 'Sikeres módosítás', status: 'success' });
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}

	const isTitleInvalid = (title.length < AFFAIR_TITLE_MIN) || (title.length > AFFAIR_TITLE_MAX);
	const isDescriptionInvalid = (description.length < AFFAIR_DESCRIPTION_MIN) || (description.length > AFFAIR_DESCRIPTION_MAX)
	const isInvalid = isTitleInvalid || isDescriptionInvalid;

	return <>
		<DeepErrorContainer error={error} isLoading={isLoading} onErrorClose={() => setError('')} >
		<Box p={2}>
			<fieldset disabled={isLoading}>
				<FormControl isInvalid={isTitleInvalid}>
					<FormLabel>Címsor</FormLabel>
					<Input isDisabled={isLoading}
						value={title} onChange={e => setTitle(e.target.value)} />
					{title.length < AFFAIR_TITLE_MIN && <FormErrorMessage>Túl rövid</FormErrorMessage>}
					{title.length > AFFAIR_TITLE_MAX && <FormErrorMessage>Túl hosszú</FormErrorMessage>}
				</FormControl>
				<FormControl isInvalid={isDescriptionInvalid}>
					<FormLabel>Leírás</FormLabel>
					<Textarea isDisabled={isLoading}
						rows={7} cols={60} value={description} onChange={e => setDescription(e.target.value)} />
					{description.length < AFFAIR_DESCRIPTION_MIN && <FormErrorMessage>Túl rövid</FormErrorMessage>}
					{description.length > AFFAIR_DESCRIPTION_MAX && <FormErrorMessage>Túl hosszú</FormErrorMessage>}

				</FormControl>
			</fieldset>
		</Box>
		<VizvCardActionStrip mt='auto'>
			<VizvButtonCancel onClick={() => vvNav.to(-1)} isDisabled={isLoading} >Mégsem</VizvButtonCancel>
			<VizvButtonPrimary ml='auto' leftIcon={<MdSave />} onClick={saveClick} isDisabled={isLoading || isInvalid}>Mentés</VizvButtonPrimary>
		</VizvCardActionStrip>
		</DeepErrorContainer>
	</>
}